import React from 'react'
import { NavDropdown, NavLinkItem } from './NavDropdown'

// Desktop nav extras for the part-time helper section. The menu was labelled
// "Services", duplicating IndexNav's site-wide Services menu.
const HELPER_SERVICES = [
    { href: '/sg/part-time-cleaner-singapore/professional-house-cleaning', label: 'Professional House Cleaning' },
    { href: '/sg/part-time-cleaner-singapore/move-in-move-out-cleaning', label: 'Move Out Cleaning' },
    { href: '/sg/part-time-cleaner-singapore/spring-cleaning', label: 'Spring Cleaning' },
    { href: '/sg/part-time-cleaner-singapore/part-time-helper-for-cooking', label: 'Cooking Assistance' },
    { href: '/sg/part-time-cleaner-singapore/part-time-babysitter-singapore', label: 'Babysitter' },
    { href: '/sg/part-time-cleaner-singapore/elderly-care', label: 'Elderly Care' },
]

export const HelperNavBar = () => (
    <>
        <NavDropdown label="Helper Services" items={HELPER_SERVICES} />
        <NavLinkItem href="/sg/part-time-cleaner-singapore/part-time-cleaner-rates-singapore" label="Rates" ariaLabel="Part-time cleaner rates" />
        <NavLinkItem href="/sg/blogs/house-keeping" label="Blogs" ariaLabel="House Keeping Blogs" />
    </>
)
